import '@fancyapps/fancybox';

$( '.image-carousel' ).each( function() {
	let $this = $( this );

	let swiper = new Swiper( this, {
		loop: true,
		pagination: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: true,
		speed: 500,
	} );

	swiper.on( 'slideChange', function() {
		let fancyboxImage = $this.find( '.swiper-slide' ).eq( swiper.realIndex ).attr( 'data-fancybox-image' );
		$this.parents( '.carousel-container' ).find( '.image-zoom' ).attr( 'href', fancyboxImage );
	} );
} );

$( '.interactive-map-carousel' ).each( function() {
	let $this = $( this );

	let swiper = new Swiper( this, {
		loop: true,
		pagination: false,
		navigation: {
			nextEl: $this.parents( '.carousel-container' ).find( '.carousel-next' )[ 0 ],
			prevEl: $this.parents( '.carousel-container' ).find( '.carousel-previous' )[ 0 ],
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		slidesPerView: 1,
		grabCursor: true,
		speed: 750,
	} );

	let navELements = $this.parents( '.carousel-container' ).find( '.swiper-nav' );

	navELements.each( function( index ) {
		$( this ).on( 'click', function() {
			swiper.slideTo( index );
			navELements.removeClass( 'active' );
			$( this ).addClass( 'active' );
		} );
	} );

	swiper.on( 'slideChange', function() {
		// Remove 'active' class from all slides
		$this.find( '.swiper-slide' ).each( function() {
			$( this ).find( '.swiper-slide-content' ).removeClass( '!translate-y-0' );
		} );

		$this.find( '.swiper-slide' ).eq( swiper.activeIndex ).find( '.swiper-slide-content' ).addClass( '!translate-y-0' );
	} );

	$( '.carousel-nav-dropdown-toggle' ).on( 'click', function( event ) {
		let $this = $( this );

		$this.parent().find( '.carousel-nav-dropdown' ).toggle( 300 );
		$this.find( '.icon' ).toggleClass( '-scale-y-100' );
	} );

	$( '.carousel-nav-dropdown a' ).on( 'click', function( event ) {
		let index = $( '.carousel-nav-dropdown a' ).index( this );

		swiper.slideToLoop( index );

		$( '.carousel-nav-dropdown a' ).removeClass( 'active' );
		$( this ).addClass( 'active' );

		let label = $( this ).html();
		$( '.carousel-nav-dropdown-title' ).html( label );

		$( '.carousel-nav-dropdown' ).slideUp( 300 );
		$( '.carousel-nav-dropdown-toggle' ).find( '.icon' ).removeClass( '-scale-y-100' );
	} );
} );

$( '.floorplans-carousel' ).each( function() {
	let $this = $( this );

	let swiper = new Swiper( this, {
		loop: true,
		pagination: false,
		navigation: {
			nextEl: [...$this.parents( '.carousel-container' ).find( '.carousel-next' )],
			prevEl: [...$this.parents( '.carousel-container' ).find( '.carousel-previous' )],
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true,
		},
		autoHeight: true,
		breakpoints: {
			1024: {
				autoHeight: false,
			},
		},
		slidesPerView: 1,
		grabCursor: true,
		speed: 750,
	} );

	const swiperNavContainer = $this.parents( '.carousel-container' ).find( '.swiper-nav-container' );

	swiperNavContainer.each( function() {
		$( this ).find( '.swiper-nav' ).each( function( index ) {
			$( this ).on( 'click', function() {
				swiperNavContainer.find( '.swiper-nav' ).removeClass( 'active' );
				swiper.slideToLoop( index );
			} );
		} );
	} );

	swiper.on( 'slideChange', function() {
		swiperNavContainer.each( function() {
			$( this ).find( '.swiper-nav' ).each( function( index ) {
				$( this ).toggleClass( 'active', index === swiper.realIndex );
			} );
		} );
		// Remove 'active' class from all slides
		$this.find( '.swiper-slide' ).each( function() {
			$( this ).find( '.swiper-slide-content' ).removeClass( '!translate-y-0' );
		} );

		$this.find( '.swiper-slide' ).eq( swiper.realIndex ).find( '.swiper-slide-content' ).addClass( '!translate-y-0' );
	} );
} );
